import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateTitle } from "../../redux/updatePageHeadeSlice";
import { ADMIN_DASHBOARD_HEADER } from "../../constants/headerTitles";
import { useQuery } from "react-query";
import getLicences from "../../api/getLicence";
import Loader from "../utilities/loader";

const LicencePage = () => {
    const [licence, setLicence] = useState(null);

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(updateTitle(ADMIN_DASHBOARD_HEADER))
    }, [])

    const { isLoading, result } = useQuery(
        ["getLicences"],
        () => getLicences(),
        {
            enabled: true,
            onSuccess: (data) => {
                setLicence(data.data.data);
            },
            onError: (err) => {
                console.log("error", err)
            }
        }
    );

    const showStatus = (status) => {
        return status === "Yes" ? "Oui" : "Non"
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    if (isLoading) return <>
        <Loader />
    </>

    return (
        <>
            <div>
                <div className="grid grid-cols-2 p-4 gap-10">
                    <div className="col-span-1 w-full mx-auto bg-white shadow-md rounded-lg overflow-hidden">
                        <div className="p-4 border-b border-gray-200">
                            <div className="flex justify-between w-full">
                                <h3 className="text-gray-800 text-lg uppercase">Informations Licence</h3>
                                <span class={`${licence.status ? "bg-yellow-100 text-yellow-800" : "bg-red-100 text-red-800 "} text-xs text-center font-medium px-2.5 pb-0.5 pt-1 rounded dark:bg-red-900 dark:text-red-300`}> {licence.status ? "Actif" : "Inactive"} </span>
                            </div>
                            <table className="min-w-full mt-4">
                                <tbody>
                                    <tr className="hover:bg-gray-50 border-b border-gray-200">
                                        <td className="p-3 text-gray-900">Entreprise</td>
                                        <td className="p-3 font-light text-gray-800">{licence.organization}</td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 border-b border-gray-200">
                                        <td className="p-3 text-gray-900">Type</td>
                                        <td className="p-3 font-light text-gray-800">Silver</td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 border-b border-gray-200">
                                        <td className="p-3 text-gray-900">Date de début</td>
                                        <td className="p-3 font-light text-gray-800">{formatDate(licence.start_date)}</td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 border-b border-gray-200">
                                        <td className="p-3 text-gray-900">Date d'expiration</td>
                                        <td className="p-3 font-light text-gray-800">{formatDate(licence.date_expiration)}</td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 border-b border-gray-200">
                                        <td className="p-3 text-gray-900">Durée de la licence</td>
                                        <td className="p-3 font-light text-gray-800">{licence.duration_in_monthes} mois</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>


                    <div className="col-span-1 w-full mx-auto bg-white shadow-md rounded-lg overflow-hidden">
                        <div className="p-4 border-b border-gray-200">
                            <h3 className="text-gray-800 text-lg uppercase">Status Quotas</h3>
                            <table className="min-w-full mt-4">
                                <tbody>
                                    <tr className="hover:bg-gray-50 border-b border-gray-200">
                                        <td className="p-3 text-gray-900 ">Utilisateurs avec profil: Admin</td>
                                        <td className="p-3 font-light text-gray-800">{licence.adminUsers == "0" ? "0" : `${licence.adminUsers}/${licence.numberOfUsers}`}</td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 border-b border-gray-200">
                                        <td className="p-3 text-gray-900 ">Utilisateurs avec profil: Master</td>
                                        <td className="p-3 font-light text-gray-800">{licence.masterUsers == "0" ? "0" : `${licence.masterUsers}/${licence.numberOfUsers}`}</td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 border-b border-gray-200">
                                        <td className="p-3 text-gray-900 ">Utilisateurs avec profil: Capture</td>
                                        <td className="p-3 font-light text-gray-800">{licence.captureUsers == "0" ? "0" : `${licence.captureUsers}/${licence.numberOfUsers}`} </td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 border-b border-gray-200">
                                        <td className="p-3 text-gray-900 ">Nombre total d'utilisateurs</td>
                                        <td className="p-3 font-light text-gray-800"> {licence.numberOfUsers}/{licence.numberOfUsers} </td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 border-b border-gray-200">
                                        <td className="p-3 text-gray-900 ">Espace disque disponible (*)</td>
                                        <td className="p-3 font-light text-gray-800"> {licence.storage_size_status} </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="col-span-1 w-full mx-auto bg-white shadow-md rounded-lg overflow-hidden">
                        <div className="p-4">
                            <h3 className="text-gray-800 text-lg uppercase">Fonctionnalités et Quotas</h3>
                            <table className="min-w-full mt-4">
                                <tbody>
                                    {[
                                        { label: 'Utilisateurs avec profil: Admin', value: `${licence.adminUsers}` },
                                        { label: 'Utilisateurs avec profil: Master', value: `${licence.masterUsers}` },
                                        { label: 'Utilisateurs avec profil: Capture', value: `${licence.captureUsers}` },
                                        { label: 'Espace de stockage maximum', value: `${licence.max_disk_storage}` },
                                        { label: 'Limite mensuelle de pages traitées par l\'OCR', value: `${licence.max_number_of_pages}` },
                                        { label: 'Création de nouveaux documents sécurisés avec QR code', value: showStatus(licence.Creation_doc_QR_code) },
                                        { label: 'Moteurs de recherche', value: showStatus(licence.ResearchEngine) },
                                        { label: 'Moteur de recherche avancé', value: showStatus(licence.AdvancedResearchEngine) },
                                        { label: 'Extracteur de données par defaut', value: showStatus(licence.DefaultReader) },
                                        // { label: 'Extracteur de données personnalisés offerts (*)', value: `${licence.CustomReadersOffered}` },
                                        { label: 'Extracteur de données personnalisés offerts (*)', value: `${licence.CustomReadersOffered}` },
                                        { label: 'Apprentissage continue des extracteurs de données', value: showStatus(licence.machineLearning) },
                                        { label: 'IA Generative', value: showStatus(licence.generativeAI) },
                                    ].map((item, index) => (
                                        <tr key={index} className="hover:bg-gray-50 border-b border-gray-200">
                                            <td className="p-3 text-gray-900 ">{item.label}</td>
                                            <td className="p-3 font-light text-gray-800">{item.value}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LicencePage;
